import { Route, Switch } from 'react-router-dom';
import React from 'react';
import Home from '../Home';
import Settings from '../Settings';
import Page404 from '../Page404';
import Site from '../Site';
import PropTypes from 'prop-types';


function Children(props) {
  const { business } = props;

  return (
    <Switch>
      <Route
        path='/business/:businessId/site/:siteId'
        render={props => (
          <Site {...props} business={business} />
        )}
      />

      <Route
        path='/business/:businessId/settings'
        render={props => (
          <Settings {...props} business={business} />
        )}
      />

      <Route
        path='/business/:businessId'
        render={props => (
          <Home {...props} business={business} />
        )}
      />

      <Route component={Page404} />
    </Switch>
  );
}

Children.propTypes = {
  business: PropTypes.object
}


export default Children;
